// extracted by mini-css-extract-plugin
module.exports = {"body":"body__CG9RU","header":"header__3P-76","title":"title__3CkX1","description":"description__1KsDo","bottom-tools":"bottom-tools__hHGi3","link-button":"link-button__185Qu"};